module.exports = __webpack_public_path__ + "img/US.53efdf30.svg";